/**
 * AUTO-GENERATED FILE, DO NOT EDIT!
 * =================================
 * This file is automatically generated through the Figma API. If you want to
 * add or update these tokens, let the DS team know through a Jira ticket.
 * Manual additions will be automatically overwritten.
 */

import classNames from 'classnames';

import type { IconProps } from '../types';

type IconPropsExtended = IconProps;

export const AddLargeIcon = ({
  className,
  ...otherProps
}: IconPropsExtended): JSX.Element => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-label="AddLargeIcon"
    role="img"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    className={classNames('cogs-icon', className)}
    {...otherProps}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 2c.432 0 .783.35.783.783v4.434h4.434a.783.783 0 0 1 0 1.566H8.783v4.434a.783.783 0 0 1-1.566 0V8.783H2.783a.783.783 0 0 1 0-1.566h4.434V2.783C7.217 2.35 7.567 2 8 2"
      clipRule="evenodd"
    />
  </svg>
);
